import { createMetricsFactory } from 'metrics-js';

export const Metrics = createMetricsFactory('foundations-components', {
  library: 'foundations-components',
});
